import { SET_BOT_VARS, SET_LABELS, SET_SEQUENCE,RESET_BOTVARS } from "../constants/BotVars";

const initState = {
  sessionVariables: [],
  labels: [],
  sequence: 1,
};

const botVars = (state = initState, action) => {
  switch (action.type) {
    case SET_BOT_VARS: {
      return {
        ...state,
        sessionVariables: action.payload,
      };
    }
    case SET_LABELS: {
      return {
        ...state,
        labels: action.payload,
      };
    }
    case SET_SEQUENCE: {
      return {
        ...state,
        sequence: action.payload,
      };
    }
    case RESET_BOTVARS: {
      return {
        sessionVariables: [],
        labels: [],
        sequence: 1,
      };
    }
    default:
      return state;
  }
};

export default botVars;
